import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WechatContactType } from "@packages/chat-sdk";

export interface WechatChatPersistentStoreType {
  fromUserId?: string;
  toUserId?: string;
  chatType?: WechatContactType;
}
export const wechatChatPersistentStore =
  new Store<WechatChatPersistentStoreType>(
    persist(
      () => ({
        fromUserId: undefined,
        toUserId: undefined,
        chatType: undefined,
      }),
      {
        name: storageKey.WECHAT_CHAT_STORAGE, // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    ) as any
  );

export const wechatChatPersistentStoreActions = {
  selectConversation(payload: {
    fromUserId?: string;
    toUserId?: string;
    chatType?: WechatContactType;
  }) {
    wechatChatPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.WECHAT_CHAT_STORAGE);
  },
};
